<div class="claims-unavailable bg-gray-200">
  <div class="row dvh-100 p-3 overflow-auto">
    <div class="col-12 col-sm-6 offset-sm-3 d-flex flex-column">
      <div class="d-flex justify-content-between align-items-start">
        <div class="logo d-block" app-logo></div>
        <app-language-switch toggleClass="btn text-uppercase no-outline dark-color-mode" />
      </div>
      <div class="d-flex flex-column flex-grow-1 justify-content-center mb-4">
        <div class="hero-image my-4"></div>
        <h2 class="mb-2">{{ 'CLAIMS_UNAVAILABLE.CLAIMS.TITLE' | translate }}</h2>
        <div class="d-flex flex-column gap-3">
          <span>{{ 'CLAIMS_UNAVAILABLE.CLAIMS.TYPE_DESCRIPTION' | translate }}</span>
        </div>
      </div>
      <button
        class="btn btn-lg btn-primary d-flex gap-2 align-items-center justify-content-center"
        (click)="onLogout()"
      >
        <i class="icon ni-logout-bracket"></i>
        <span>{{ 'USER.LOGOUT' | translate }}</span>
      </button>
    </div>
  </div>
</div>
